import { ReactNode, useEffect, useState } from 'react';

import { useMap, useMapEvents } from 'react-leaflet';

import { IOrgInfo, useSetOrgInfo } from '~entities/kindergarten/organization';

import { useTranslation } from '~shared/lib/i18n/i18n';
import { Button, Modal, useNotification, useWindowInnerWidth } from '~shared/ui';

import { OpenStreetMapView } from '~entities/shared/map';

import { updateOrgCoordinates } from '../../api';

export interface OrgCoordinatesEditViewProps {
  info?: IOrgInfo;
  button: ReactNode;
}

export const OrgCoordinatesEditView: React.FC<OrgCoordinatesEditViewProps> = ({ button, info }) => {
  const { t } = useTranslation();
  const notification = useNotification();
  const windowWidth = useWindowInnerWidth();
  const setOrgInfo = useSetOrgInfo();

  const [modal, setModal] = useState(false);
  const [coords, setCoords] = useState<[number, number]>([0, 0]);

  const handleModal = () => {
    setModal(!modal);
    setCoords([parseFloat(info!.y), parseFloat(info!.x)]);
  };

  function ClickHandler() {
    useMapEvents({
      click(e: any) {
        setCoords([e.latlng.lat, e.latlng.lng]);
      },
    });

    return null;
  }

  const MapUpdater = ({ coords }: { coords: [number, number] }) => {
    const map = useMap();

    useEffect(() => {
      if (coords) {
        map.setView(coords, map.getZoom()); // Обновляем центр карты
      }
    }, [coords, map]);

    return null;
  };

  const onSave = async () => {
    const data = {
      lat: String(coords[0]),
      lng: String(coords[1]),
    };

    const response = await updateOrgCoordinates(data);

    if (!response?.error) {
      notification.openNotification({
        message: t('notify.succesSaved'),
        type: 'success',
      });

      setOrgInfo({ idOrganization: info!.id_organization });
      setModal(false);
    }

    if (response?.error) {
      return notification.openNotification({
        message: response?.message,
        type: 'error',
      });
    }
  };

  return (
    <>
      {notification.contextHolder}
      <div onClick={handleModal}>{button}</div>

      <Modal
        open={modal}
        onCancel={handleModal}
        title={t('organization:сoordinates')}
        footer={false}
        width={1024}
        centered
      >
        <div className="grid gap-6">
          <div className="rounded border-solid border border-stroke overflow-hidden">
            <OpenStreetMapView
              key={'orgCoordinates' + windowWidth + JSON.stringify(Date.now())}
              zoom={13}
              coords={coords}
              ClickHandler={<ClickHandler />}
              MapUpdater={<MapUpdater coords={coords} />}
              width="100%"
              height="60vh"
            />
          </div>
          <div className="flex justify-between items-center">
            <p>{t('organization:сoordinatesErrDescription')}</p>
            <Button type="primary" onClick={onSave}>
              {t('actions.save')}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
